import { render, staticRenderFns } from "./SetContactInformation.vue?vue&type=template&id=09bbaead&"
import script from "./SetContactInformation.vue?vue&type=script&lang=ts&"
export * from "./SetContactInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports